export const ABOUT_HERO_CONTENT = {
  eyebrow: 'WHO WE ARE',
  title: 'Guided By Faith, Driven By',
  highlight: 'Knowledge',
  description:
    'We are a dedicated online Quran learning platform connecting students across the globe with certified, passionate Quran teachers — making authentic Islamic education accessible for every family.',
  breadcrumbLabel: 'About Us',
}
